import React from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { chevronBackOutline as backIcon } from "ionicons/icons";

import styles from "./EmbeddedHeader.module.scss";

type Props = {
  title: string;
  rightComponent?: React.ReactNode;
  goBack?: () => void;
};

const EmbeddedHeader = ({ title, rightComponent, goBack }: Props) => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.headerContainer}>
        <IonButton
          fill="clear"
          onClick={() => {
            if (goBack) {
              goBack();
              return;
            }
            window.history.back();
          }}
        >
          <IonIcon icon={backIcon} className={styles.backIcon} />
        </IonButton>
        <p className={styles.headerTitle}>{title}</p>
        <div className={styles.rightComponent}>{rightComponent}</div>
      </div>
      <hr />
    </div>
  );
};

export default EmbeddedHeader;
